import React from 'react';
import { reduxForm, Field } from 'redux-form';
import InputField from './InputField';
import CheckboxField from './CheckboxField';
import SelectField from './SelectField';
import FormError from './FormError';
import { formatSaveStatus } from '../helpers/formatters';
import { allAclGroups } from 'helpers/user';

const aclGroupOptions = allAclGroups.map((value) => [value, value]);

let SearchUsersForm = ({
  handleSubmit,
  saveStatus,
  userTypes,
  error,
  fields = [
    'first_name',
    'last_name',
    'email',
    'acl_group_name',
    'city',
    'state',
    'zip_code',
    'staff',
  ],
}) => (
  <form onSubmit={handleSubmit}>
    {fields.includes('first_name') && (
      <Field component={InputField} name="first_name" />
    )}
    {fields.includes('last_name') && (
      <Field component={InputField} name="last_name" />
    )}
    {fields.includes('email') && <Field component={InputField} name="email" />}
    {fields.includes('acl_group_name') && (
      <Field
        component={SelectField}
        label="Acl Group Name"
        name="acl_group_name"
        options={userTypes ? userTypes : aclGroupOptions}
        empty="Any"
      />
    )}

    {fields.includes('city') && <Field component={InputField} name="city" />}
    {fields.includes('state') && <Field component={InputField} name="state" />}
    {fields.includes('zip_code') && (
      <Field component={InputField} name="zip_code" />
    )}

    {fields.includes('staff') && (
      <Field component={CheckboxField} name="staff" label="Staff" />
    )}

    {error && <FormError error={error} />}
    <br />
    <button className="btn btn-default" disabled={saveStatus === 'PENDING'}>
      Search Users
    </button>
    <span className="submit-status">{formatSaveStatus(saveStatus)}</span>
  </form>
);

SearchUsersForm = reduxForm({
  form: 'searchUsers',
})(SearchUsersForm);

export default SearchUsersForm;
